import { render, staticRenderFns } from "./DocumentPropertyDialog.vue?vue&type=template&id=fba59edc&"
import script from "./DocumentPropertyDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentPropertyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports